import { axiosInstance } from "../../../util/axios";
import {
  trackOrderBaseUrlSelector,
  getTrackOrderAuthToken,
} from "../../../Api/ApiHelper";

export const fetchOrderByOrderNumber = ({ orderNumber }) => {
  const baseUrl = trackOrderBaseUrlSelector();
  const url = `${baseUrl}`;
  const authToken = getTrackOrderAuthToken();
  const data = JSON.stringify({
    ordernumber: orderNumber,
  });
  return axiosInstance.post(url, data, {
    headers: {
      Authorization: authToken,
    },
  });
};
